import { addUser, apiToken, changePasswordURL, editUserProfile, getAllUser, getUserProfile } from "../config";

// get users from organization
export const getUsersFromOrganisationId = async (orgId, page = 1, numberOfResult = 20) => {
  try {
    const uri = `${getAllUser}?page=${page}&limit=${numberOfResult}&organizationId=${orgId}`

    const userResponse = await fetch(uri, {
      method: 'GET', 
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${apiToken}`
      }
    });

    if (!userResponse.ok) {
      throw new Error('Network response was not ok');
    }


    const response = await userResponse.json();
    return response;
  } catch (e) {
    console.error(e);
  } finally {

  }
};
// get users from organization ended


// get all users start
export const getAllUsers = async (page=1, limit=20) => {
    try {
        const uri = `${getAllUser}?page=${page}&limit=${limit}`;
        const response = await fetch(uri, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            }
        })
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data;
    } catch(e) {
        console.error(e);
    }
}

// get all user end

// register user start

export const registerUser = async (data) => {
  try {
    const response = await fetch(addUser, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${apiToken}`,
      },
      body: JSON.stringify(data),
    });

    const json = await response.json();

    if (!response.ok) {
      // Throw meaningful error so calling function can catch it
      throw new Error(json.message || 'Registration failed');
    }

    return json;
  } catch (e) {
    console.error('Register Error:', e);
    // Important: Rethrow for the form to catch and show toast
    throw e;
  }
};

// register user end

// get user profile

export const getUserProfileData = async () => {
  try {
    const response = await fetch(getUserProfile, {
      method: 'GET',
     headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiToken}`
     }
    });
    const res = await response.json();
    if (!response.ok) {
      throw new Error(res.message || "Network response was not ok");
    }
    return res;
  } catch(e) {
    throw new Error(e.message || "Error");
  }
}

// end user profile

// Start edit user profile

export const editProfile = async (data) => {
  try {
    const response = await fetch(editUserProfile, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${apiToken}`
      },
      body: JSON.stringify(data)
    });
    const res = await response.json();
    if (!response.ok) {
      throw new Error(res.message || "Network response was not ok");
    }
    return res;
  } catch(e) {
    throw new Error(e.message || "Failed")
  }
}

// end edit profile

// start change password

export const changePassword = async (data) => {
  try {
    //console.log(data)
    const response = await fetch(changePasswordURL, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
         Authorization: `Bearer ${apiToken}`
      },
      body: JSON.stringify(data)
    });
    const res = await response.json()
    //console.log(res)

    if (!response.ok) {
      throw new Error(res.message || "Network response was not ok")
    }
    return res;
  } catch(e) {
    throw new Error(e.message || "Failed")
  } 
}

// end change password
